export const ALL_FILTER = "all";
export const PPC_FILTER = "ppc";
export const ALL_ALERTS = "all_alerts";
export const FOLLOWED_ALERTS = "followed_alerts";
export const updateTypes = {
  UNFILTERED: "unfiltered",
  PPC: "ppc",
};
